import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFile = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M3.25 20V4A2.75 2.75 0 0 1 6 1.25h7c.199 0 .39.08.53.22l7 7c.14.14.22.331.22.53v11A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20m1.5 0c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V9.31l-6.56-6.56H6c-.69 0-1.25.56-1.25 1.25z"
    />
    <path
      fill="currentColor"
      d="M12.25 2a.75.75 0 0 1 1.5 0v6.25H20a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75z"
    />
  </svg>
);
export default SvgFile;
